import React from 'react';

export function Dashboard(props) {
  return (
    <div style={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
      <p>Under Construction</p>
    </div>
  );
};
